var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"v-app"},[_c('ApplicationTopToolbar'),_c('ApplicationErrorSnackbar'),_c('ApplicationWarningSnackbar'),_c('v-main',{staticClass:"main-container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }